var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSertificateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H11V11C11.0001 8.23863 13.2386 6 16 6C16.7111 6 17.3875 6.14845 18 6.41604V2C18 0.895431 17.1046 0 16 0H2ZM4 3C3.44772 3 3 3.44772 3 4C3 4.55228 3.44772 5 4 5H9C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3H4ZM4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9H6C6.55228 9 7 8.55228 7 8C7 7.44772 6.55228 7 6 7H4Z",
    fill: "#985EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.76389C17.4692 8.28885 16.7684 8 16 8C14.3432 8 13.0001 9.34308 13 10.9999C13 10.9998 13 10.9999 13 10.9999C13 11.7682 13.2887 12.4692 13.7637 13C14.3131 13.6139 15.1114 14.0002 16 14.0002C16.8886 14.0002 17.6869 13.6139 18.2363 13C18.7113 12.4692 19 11.7684 19 11C19 10.1115 18.6137 9.31321 18 8.76389Z",
    fill: "#985EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.0005V19.0657C13 19.4651 13.4451 19.7033 13.7774 19.4818L14.8906 18.7396C15.5624 18.2917 16.4376 18.2917 17.1094 18.7396L18.2227 19.4818C18.5549 19.7033 19 19.4651 19 19.0657V15.0005C18.1643 15.6282 17.1256 16.0002 16 16.0002C14.8744 16.0002 13.8357 15.6282 13 15.0005Z",
    fill: "#985EFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSertificateIcon);
export default __webpack_public_path__ + "static/media/sertificate_icon.b223a3887deef3d98ea789e8a25d9e22.svg";
export { ForwardRef as ReactComponent };